import { Navigate, Outlet } from "react-router-dom";

function readPerms() {
  try {
    return JSON.parse(localStorage.getItem("permisos") || "[]");
  } catch {
    return [];
  }
}

export default function RequirePerm({ perm, redirectTo = "/administrator_jx677" }) {
  const perms = readPerms();
  const ok = perms.includes(perm);

  if (!ok) return <Navigate to={redirectTo} replace />;

  return <Outlet />;
}
